const publishURL = process.env.VUE_APP_CML_PUBLISH_URL;
const baseURL = process.env.VUE_APP_CML_BASE_URL;
const downURL = process.env.VUE_APP_CML_DOWN_URL;
export { publishURL, baseURL, downURL };
